import React, { useEffect, useState } from "react";
import { Card, Col, Select, Table, Tag, message } from "antd";
import dayjs from "dayjs";

import ReportFilterBar from "../components/ReportFilterBar";
import ReportExportButton from "../components/ReportExportButton";
import { fetchLeadStatusChangeReportApi, fetchLeadStatusApi } from "../../../apiservice/crm";

const today = dayjs().format("YYYY-MM-DD");

const LeadStatusChangeReport = () => {
  const [filters, setFilters] = useState({ fromDate: today, toDate: today });
  const [data, setData] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLeadStatusApi().then((res) => setStatusList(res?.data || [])).catch(() => setStatusList([]));
  }, []);

  const load = async (nextFilters = filters) => {
    setLoading(true);
    try {
      const res = await fetchLeadStatusChangeReportApi(nextFilters);
      setData(res.data?.data || []);
    } catch (err) {
      message.error(err?.response?.data?.message || "Failed to load lead status change report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const columns = [
    { title: "Lead Name", dataIndex: "lead_name" },
    { title: "Phone", dataIndex: "contact_no" },
    {
      title: "Status Change",
      render: (_, row) => (
        <>
          <Tag>{row.old_status || "Unknown"}</Tag>
          <span style={{ margin: "0 4px" }}>→</span>
          <Tag color="blue">{row.new_status}</Tag>
        </>
      ),
    },
    {
      title: "Changed On",
      dataIndex: "status_changed_at",
      render: (v) => (v ? dayjs(v).format("DD/MM/YYYY hh:mm A") : "-"),
    },
    { title: "Assigned To", dataIndex: "assigned_user" },
    { title: "Source", dataIndex: "source" },
    {
      title: "Lead Created On",
      dataIndex: "lead_created_date",
      render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
    },
  ];

  return (
    <>
      <ReportFilterBar
        filters={filters}
        onChange={(partial) => setFilters((f) => ({ ...f, ...partial }))}
        onApply={() => load()}
        onReset={() => {
          const reset = { fromDate: today, toDate: today };
          setFilters(reset);
          load(reset);
        }}
        loading={loading}
        extra={
          <Col xs={24} sm={12} md={8} lg={5}>
            <label>Status</label>
            <Select
              allowClear
              placeholder="Any Status"
              style={{ width: "100%" }}
              size="large"
              value={filters.status_id || undefined}
              onChange={(v) => setFilters((f) => ({ ...f, status_id: v || null }))}
              options={statusList.map((s) => ({ label: s.name, value: s.id }))}
            />
          </Col>
        }
      />

      <Card
        title="Lead Status Change Report"
        extra={<ReportExportButton reportType="lead-status-changes" filters={filters} />}
      >
        <Table
          rowKey="log_id"
          columns={columns}
          dataSource={data}
          loading={loading}
          bordered
          scroll={{ x: "max-content" }}
        />
      </Card>
    </>
  );
};

export default LeadStatusChangeReport;
